import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { agentExecutionsApi } from '@/lib/api/agent-executions.api';

const QK = ['agent-executions'];

export function useQualityExecutions(page: number, pageSize: number) {
  return useQuery({
    queryKey: [...QK, 'quality', page, pageSize],
    queryFn: () => agentExecutionsApi.listQuality(page, pageSize),
    placeholderData: keepPreviousData,
  });
}

export function useQualityExecutionDetail(callId: string | undefined, name: string | undefined) {
  return useQuery({
    queryKey: [...QK, 'quality', callId, name],
    queryFn: () => agentExecutionsApi.getQuality(callId!, name!),
    enabled: !!callId && !!name,
  });
}

export function useClassificationExecutions(page: number, pageSize: number) {
  return useQuery({
    queryKey: [...QK, 'classifications', page, pageSize],
    queryFn: () => agentExecutionsApi.listClassifications(page, pageSize),
    placeholderData: keepPreviousData,
  });
}

export function useClassificationExecutionDetail(
  callId: string | undefined,
  name: string | undefined,
) {
  return useQuery({
    queryKey: [...QK, 'classifications', callId, name],
    queryFn: () => agentExecutionsApi.getClassification(callId!, name!),
    enabled: !!callId && !!name,
  });
}
